import React, { useContext, useState, useEffect } from 'react';
import { dbPost } from '../../apis/commonApi';
import { GlobalContext, ModalContext } from '../../components/contexts';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';

const PayList = () => {
  const { modalService } = useContext(ModalContext);

  useEffect(() => {
      document.title = '결제 목록';
    }, []);

  const { store } = useContext(GlobalContext);
  const [payList, setPayList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const formatDate = dateString => {
    if (!dateString || dateString.length !== 8) return '';
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    return `${year}.${month}.${day}`;
  };

const getStatus = (startDate, endDate) => {
  if (
    !startDate ||
    !endDate ||
    startDate.length !== 8 ||
    endDate.length !== 8
  ) {
    return <span className="krds-badge bg2">결제 실패</span>;
  }

  const today = new Date();
  const start = new Date(
    parseInt(startDate.slice(0, 4)),
    parseInt(startDate.slice(4, 6)) - 1,
    parseInt(startDate.slice(6, 8))
  );
  const end = new Date(
    parseInt(endDate.slice(0, 4)),
    parseInt(endDate.slice(4, 6)) - 1,
    parseInt(endDate.slice(6, 8))
  );

  if (start <= today && today <= end) {
    return <span className="krds-badge bg1">이용중</span>;
  }
  return <span className="krds-badge bg2">종료</span>;
};


  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const paginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return payList.slice(startIndex, startIndex + itemsPerPage);
  };

const fetchData = async () => {
  try {
    const url = '/pay/paid/list.do';
    const response = await dbPost(url, { entSn: store?.entSn });

    const today = new Date();
    const filteredList = response.filter(item => {
      const status = getStatus(item.useStrtYmd, item.useEndYmd);
      return status.props.children !== '결제 실패';
    });

    const sortedList = filteredList.sort((a, b) => {
      const startA = new Date(
        parseInt(a.useStrtYmd.slice(0, 4)),
        parseInt(a.useStrtYmd.slice(4, 6)) - 1,
        parseInt(a.useStrtYmd.slice(6, 8))
      );
      const endA = a.useEndYmd
        ? new Date(
            parseInt(a.useEndYmd.slice(0, 4)),
            parseInt(a.useEndYmd.slice(4, 6)) - 1,
            parseInt(a.useEndYmd.slice(6, 8))
          )
        : today;

      const startB = new Date(
        parseInt(b.useStrtYmd.slice(0, 4)),
        parseInt(b.useStrtYmd.slice(4, 6)) - 1,
        parseInt(b.useStrtYmd.slice(6, 8))
      );
      const endB = b.useEndYmd
        ? new Date(
            parseInt(b.useEndYmd.slice(0, 4)),
            parseInt(b.useEndYmd.slice(4, 6)) - 1,
            parseInt(b.useEndYmd.slice(6, 8))
          )
        : today;

      const isAInUse = startA <= today && today <= endA;
      const isBInUse = startB <= today && today <= endB;

      if (isAInUse && !isBInUse) return -1;
      if (!isAInUse && isBInUse) return 1;

      return startB - startA;
    });

    setPayList(sortedList);
  } catch (error) {
    setPayList([]);
  }
};

  const handleCancelSubscription = async stlmId => {
    modalService.confirmAlert(
      {
        msg: '정말 해지하시겠습니까?',
        cnt: '한 번 해지한 구독 결제는 다시 되돌릴 수 없습니다.',
      },
      [
        async () => {
          try {
            const url = '/pay/update.do';
            const response = await dbPost(url, { stlmId });

            if (response === 1) {
              modalService.successAlert('구독이 해지되었습니다.');
              fetchData();
            } else {
              modalService.errorAlert(
                '구독 해지 중 문제가 발생했습니다. 다시 시도해주세요.'
              );
            }
          } catch (error) {
            modalService.errorAlert(
              '구독 해지 중 문제가 발생했습니다. 다시 시도해주세요.'
            );
          }
        },
        () => {},
      ]
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="contents">
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">구독내역</h2>
      </div>
      <div className="tbl-wrap">
        <h3 className="block-tit">구독내역</h3>
        <table className="tbl col data scroll">
          <caption>구독내역 목록을 확인할 수 있는 테이블입니다.</caption>
          <thead>
            <tr>
              <th scope="col">상태</th>
              <th scope="col">상품명</th>
              <th scope="col">사용기간</th>
              <th scope="col">결제금액</th>
              <th scope="col">정기결제</th>
            </tr>
          </thead>
          <tbody>
            {payList.length > 0 ? (
              paginatedData().map(
                ({
                  stlmId,
                  subCtgryNm,
                  useStrtYmd,
                  useEndYmd,
                  stlmAmt,
                  autoStlmYn,
                }) => (
                  <tr key={stlmId}>
                    <td>{getStatus(useStrtYmd, useEndYmd)}</td>
                    <td>
                      <strong>{subCtgryNm}</strong>
                    </td>
                    <td>
                      {formatDate(useStrtYmd)} ~ {formatDate(useEndYmd)}
                    </td>
                    <td>
                      <strong>{stlmAmt.toLocaleString()} 원</strong>
                    </td>
                    <td>
                      {autoStlmYn === 'Y' ? (
                        <button
                          type="button"
                          className="btn sm tertiary"
                          onClick={() => handleCancelSubscription(stlmId)}
                        >
                          해지
                        </button>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center' }}>
                  결제 내역이 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <GbitTablePaging
        totalItems={payList.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default PayList;
